export interface WidgetLoaderProps {
  loaderContainerClasses: string;
  loaderClasses: string;
}
export default function WidgetLoader({
  loaderContainerClasses,
  loaderClasses
}: WidgetLoaderProps): JSX.Element {
  return (
    <div className="loader-position">
      <div className={loaderContainerClasses}>
        <div className={`${loaderClasses} content-loader`}></div>
      </div>
    </div>
  );
}
